import React, { useState } from "react";
import apiClient from "../api/apiClient";
import { useCart } from "./CartContext";
import { useNavigate } from "react-router-dom";

const Checkout = () => {
  const { cart, clearCart } = useCart();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom_client: "",
    prenom_client: "",
    nom_compagnie: "",
    email: "",
    numero_tel: "",
    localite: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const commandeData = {
        nom_client: formData.nom_client,
        prenom_client: formData.prenom_client,
        nom_compagnie: formData.nom_compagnie,
        adresse_email: formData.email,
        numero_tel: formData.numero_tel,
        localite: formData.localite,
        produits: cart.map((item) => ({
          id_prod: item.id_prod,
          quantite: item.quantity,
        })),
      };

      const response = await apiClient.post(`/commandes`, commandeData);

      if (response.data.message === "Commande ajoutée avec succès") {
        setSuccess(true);
        clearCart();
        // Rediriger après 3 secondes
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        throw new Error("Erreur lors de la création de la commande");
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          error.message ||
          "Erreur lors de la création de la commande"
      );
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <main className="main-bg">
        <section className="checkout-section pt-120 pb-80">
          <div className="container py-5">
            <div className="text-center">
              <div className="success-icon mb-4">
                <i className="fas fa-check-circle fa-5x text-success"></i>
              </div>
              <h2 className="text-success">Commande effectuée avec succès!</h2>
              <p>
                Merci pour votre commande. Notre équipe vous contactera dans les
                plus brefs délais.
              </p>
              <p className="text-muted">
                Vous allez être redirigé vers la page d'accueil dans quelques
                secondes...
              </p>
            </div>
          </div>
        </section>
      </main>
    );
  }

  if (cart.length === 0) {
    return (
      <main className="main-bg">
        <section className="checkout-section pt-120 pb-80">
          <div className="container py-5">
            <div className="text-center">
              <div className="empty-cart-icon mb-4">
                <i className="fas fa-shopping-cart fa-5x text-muted"></i>
              </div>
              <h2>Votre panier est vide</h2>
              <p className="mb-4">
                Ajoutez des produits à votre panier avant de procéder au
                paiement.
              </p>
              <a href="/produits" className="theme-btn style-one mt-4">
                <i className="fas fa-shopping-bag me-2"></i>
                Continuer vos achats
              </a>
            </div>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="main-bg">
      <section className="checkout-section pt-120 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="checkout-form">
                <h3>Informations de livraison</h3>
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Nom *</label>
                        <input
                          type="text"
                          name="nom_client"
                          className="form_control"
                          value={formData.nom_client}
                          onChange={handleInputChange}
                          required
                          placeholder="Votre nom"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Prénom</label>
                        <input
                          type="text"
                          name="prenom_client"
                          className="form_control"
                          value={formData.prenom_client}
                          onChange={handleInputChange}
                          placeholder="Votre prénom"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Nom de la compagnie *</label>
                    <input
                      type="text"
                      name="nom_compagnie"
                      className="form_control"
                      value={formData.nom_compagnie}
                      onChange={handleInputChange}
                      required
                      placeholder="Entrez le nom de votre entreprise"
                    />
                  </div>

                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      className="form_control"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="exemple@entreprise.com"
                    />
                  </div>

                  <div className="form-group">
                    <label>Téléphone *</label>
                    <input
                      type="tel"
                      name="numero_tel"
                      className="form_control"
                      value={formData.numero_tel}
                      onChange={handleInputChange}
                      required
                      placeholder="620524579"
                    />
                  </div>

                  <div className="form-group">
                    <label>Localité *</label>
                    <input
                      type="text"
                      name="localite"
                      className="form_control"
                      value={formData.localite}
                      onChange={handleInputChange}
                      required
                      placeholder="Ville, région, adresse"
                    />
                  </div>

                  <button
                    type="submit"
                    className="theme-btn style-one w-100 d-flex justify-content-center align-items-center mt-4"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Traitement...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-paper-plane me-2"></i>
                        Envoyer la demande
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="order-summary">
                <h3>Résumé de la commande</h3>
                <div className="order-products">
                  {cart.map((item) => (
                    <div key={item.id_prod} className="order-product-item mb-3">
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            item.images && item.images[0]
                              ? `${process.env.REACT_APP_API_URL}/${item.images[0]}`
                              : "assets/images/products/cart-1.jpg"
                          }
                          alt={item.nom_prod}
                          className="order-product-img"
                          onError={(e) => {
                            e.target.src = "assets/images/products/cart-1.jpg";
                          }}
                        />
                        <div className="product-info ms-3">
                          <h6 className="mb-1">{item.nom_prod}</h6>
                          <p className="mb-0 text-muted">
                            Quantité: {item.quantity}
                          </p>
                          {item.prix && (
                            <p className="mb-0">
                              Prix: <strong>{item.prix} €</strong>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="order-total mt-4 pt-3 border-top">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Total des articles:</span>
                    <span>
                      {cart.reduce(
                        (total, item) => total + (item.quantity || 0),
                        0
                      )}
                    </span>
                  </div>
                  <div className="alert alert-info mt-3">
                    <small>
                      <i className="fas fa-info-circle me-2"></i>
                      Notre équipe vous contactera pour confirmer les prix et
                      les détails de livraison.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Checkout;
